import { Observable } from 'rxjs/Observable';
import { AbstractControl } from '@angular/forms';
import { startWith } from 'rxjs/operators/startWith';
import { map } from 'rxjs/operators/map';

export interface IFilterComplete {
  Name: string;
  Id: number;
  Filter?: string | null;
}

export class FilterCompleteService<T extends IFilterComplete> {

  constructor(private items: T[], private control: AbstractControl) {
    if (this.control && items) {
      this.filteredOptions = this.control.valueChanges
        .pipe(
          startWith<string | T>(''),
          map(value => typeof value === 'string' ? value : value ? value.Name : ''),
          map(name => this.filter(name))
        );
    }

    if (!this.control) {
      this.filteredOptions = new Observable<IFilterComplete[]>();
    }

    if (!items) {
      items = [];
    }
  }

  public filteredOptions: Observable<IFilterComplete[]>;

  filter(name?: string): T[] {
    return name ? this.items.filter(option => option &&
      (option.Name.toLowerCase().indexOf(name.toLowerCase()) > -1 ||
        (option.Filter || '').toLowerCase().indexOf(name.toLowerCase()) > -1)) : this.items.slice();
  }

  public displayFn(item?: T): string | undefined {
    return item ? item.Name : undefined;
  }

}
